<template>
    <div class="session">
        <div v-show="!getUser">
                <h1>Connexion</h1>
                <span id="invalid" v-if="invalidLogin">Identifiants invalides</span>
            <form v-on:submit.prevent="log()">
                <label id="label">Adresse email</label><br/>
                <input type="text" v-model="loginEmail" placeholder="Email" required="required" /><br/>

                <label>Mot de passe</label><br/>
                <input type="password" v-model="loginPassword" placeholder="********" required="required" /><br/>
                <span><router-link to="/register">Inscription</router-link></span><br/>
                <span><router-link to="/recover">Mot de passe oublié ?</router-link></span>
                <button type="submit" id="logButton">OK</button>
            </form>
        </div>
        <div v-show="getUser">
           <!-- <img src="/static/img/userDefault.png" />-->
            <h1>{{ email }}</h1><br/>
            <ul>
                <li>
                    <!-- <router-link to="/profile">Mon profil</router-link> -->
                </li>
                <li>
                    <!-- <router-link to="/settings">Paramètres</router-link> -->
                </li>
                <li>
                    <router-link :to="'/'" v-on:click.native="logout()">Déconnexion</router-link>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import AuthenticationService from '../services/authentication.js'
    import UsersService from '../services/users.js'
    import { mapGetters } from 'vuex'

    export default {
        name: 'login',
        data: function () {
            return {
                user: this.$store.state.user,
                token: null,
                email: "",
                invalidLogin: false,
                loginEmail: null,
                loginPassword: null,
            }
        },
        created: function () {
            if (this.$store.getters.loggedIn) {
                this.token = this.$store.getters.loggedIn;
                this.setLoggedUser();
            }
            AuthenticationService.registerOnLogin(this.onLogin)
        },
        destroyed: function () {
            AuthenticationService.unregisterOnLogin(this.onLogin)
        },

        methods: {
            // IController
            isInvalid: function() {
                this.invalidLogin = false;
            },

            showLoginError: function () {
                this.invalidLogin = true;
                setTimeout(this.isInvalid, 5000)
            },

            log: function () {
                this.$store.dispatch('retrieveToken', {
                    email: this.loginEmail,
                    passwordHash: this.loginPassword,
                }).then((res) => {
                    this.token = res.data;
                    this.setLoggedUser();
                    this.$router.replace('/');
                }, (res) => {
                    this.showLoginError()
                });
                this.loginEmail = this.loginPassword = '';
            },

            setLoggedUser: function () {
                AuthenticationService.getUserByToken({
                    token: this.token
                }).then((res) => {
                    this.user = res.body[0];
                    this.email = this.user.email;
                    this.$store.commit('setUser', this.user);
                }, (res) => {
                    console.log(res);
                });
            },

            removeLoggedUser: function () {
                this.user = null;
            },

            logout: function () {
                AuthenticationService.logout()
                    .then((res) => {
                        this.removeLoggedUser()
                    })
                localStorage.clear()
                this.user = null;
                this.$store.commit('setUser', null);
            },
            onLogin: function (user) {
                this.setLoggedUser()
            }

        },
        mounted: function (user) {
        },

        computed: {
            ...mapGetters(['getUser'])
        }
    }
</script>

<style>
    .session {
        position: absolute;
        z-index: 1;
        color: white;
        display: block;
        min-width: 190px;
    }
    @media screen and (max-width: 1280px) {
            .session{
                /*opacity: 0;*/
            }
            
    }

    .session:after {
        content: "";
        display: block;
        position: absolute;
        top: 0px;
        left: 0px;
        width: 0;
        height: 0;
        border-top: 225px solid #00579b;
        border-right: 418px solid transparent;
        z-index: -1;
    }

    .session h1 {
        font-size: 1.1em;
        margin: 0px;
        color: white;
        float: left;
    }
     
    .session #logButton {
        width: 50px;
        height: 58px;
        background: url("/static/img/arrow.png") center left no-repeat;
        border: none;
        position: absolute;
        left: 190px;
        top: 50px;
        cursor: pointer;
        padding-right: 20px;
        color: white;
        font-family: 'quicksandbook', Arial, sans-serif;
        transition-property: all;
        /* Active la transition */
        transition-duration: 200ms;
    }

    .session #logButton:hover {
        left: 200px;
    }

    .session a {
        color: white;
        font-size: 0.7em;
    }

    .session a:hover {
        text-decoration: none;
    }

    .session div {
        margin: 10px;
    }

    .session label {
        display: inline-block;
    }

    .session ul {
        font-size: 1.3em;
        margin: 0px;
        margin-right: 0%;
    }

    .session #invalid {
        display: inline-block;
        font-weight: bold;
        float: left;
        padding: 5px;
        margin-left: 35px;
        border-radius: 10px 10px 10px 0px;
        background: white;
        color: red;
        -webkit-transition: 1s;
    }
</style>



// WEBPACK FOOTER //
// Login.vue?e86d49e8